import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initFilter = {
    auth: null,
    flow: null,
    name: null,
    provider: null,
    type: null,
};
export const initSort = {
    property: "endpoint_count",
    reverse: true,
};
/** Initial state for SaaSBOM table pagination */
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
};
const saasbomSlice = createSlice({
    name: "saasbom",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = initPagination;
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id] = action.payload.pagination;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "saasbom");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
    },
});
export const saasbomReducer = saasbomSlice.reducer;
export const { filterUpdated, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, focusedRowUpdated, } = saasbomSlice.actions;
export const selectFilter = (state) => state.report.saasbom.filter;
export const selectSort = (state) => state.report.saasbom.sort;
export const selectPagination = (state) => state.report.saasbom.pagination;
export const selectExpandedRow = (state, id) => state.report.saasbom.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a; return (_a = state.report.saasbom.expandedRows[id]) !== null && _a !== void 0 ? _a : initPagination; };
export const selectFocusedRow = (state) => state.report.saasbom.focusedRow;
export * as default from "./saasbomSlice";
//# sourceMappingURL=saasbomSlice.js.map